import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';


const styles = theme => ({
  container: {
    display: 'flex',
    // flexWrap: 'wrap',
    padding : theme.spacing.unit   , 
    marginBottom: 1,
    // justifyContent: 'center',
    width: "100%"
  },
  // textField: {
  //   marginLeft: theme.spacing.unit,
  //   marginRight: theme.spacing.unit,
  //   width: 220,
  //   fontsize: 14,
  // },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  label: {
    padding: 5,
    marginBottom: theme.spacing.unit,
  },
  txtField: {
    // padding: 5,
    // fontSize: 14,
    // // marginRight: theme.spacing.unit*2,
    // margin: theme.spacing.unit,
    // display: 'block',
    // float: 'left',
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  }
});

class DatePickers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      dtFrom: '',
      dtTo: ''
    };

    this.handleChangedtFrom = this.handleChangedtFrom.bind(this);
    this.handleChangedtTo = this.handleChangedtTo.bind(this);
  }

  handleChangedtFrom = event => {
    // event.preventDefault(); 
    this.setState({ dtFrom: event.target.value });
  };

  handleChangedtTo = event => {
    this.setState({ dtTo: event.target.value });
  }

  handleOpen = () => {
    // (data) => this.props.actions.updateVehicles(data));
    this.setState({ open: true });
  };

  render() {
    const { classes } = this.props;
    // let dt = new Date().toISOString();
    function pad(number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    };


    let dtnow = new Date();
    let dt = dtnow.getUTCFullYear() +
      '-' + pad(dtnow.getUTCMonth() + 1) +
      '-' + pad(dtnow.getUTCDate()) +
      'T' + pad(dtnow.getUTCHours()) +
      ':' + pad(dtnow.getUTCMinutes()) +
      ':' + pad(dtnow.getUTCSeconds());
    // '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
    // 'Z';

    // dt = dt.toISOString(); 
    console.log('dt', dt);

    return (
      <form className={classes.container} noValidate>
        <TextField
          id="from"
          label="From"
          type="datetime-local"
          defaultValue={dt}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={this.handleChangedtFrom}
        />
        <TextField
          id="to"
          label="To"
          type="datetime-local"
          defaultValue={dt}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={this.handleChangedtTo}
        />

        <div>
          <Button color="secondary" onClick={() => this.props.submit(this.state.dtFrom, this.state.dtTo)} variant="contained" className={classes.button}>
            Go
      </Button>
          {/* <Button color="secondary" onClick={this.props.realtimeclick} variant="contained" className={classes.button}>
                  RealTime
      </Button> */}
        </div>
      </form>
    );
  }
}

DatePickers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DatePickers);